import { useDefaultsLinkPost } from '../../../../..//api/defaults/links'
import React, { useEffect } from 'react'
import { IDefaultLink, TSchemaAddLink } from '../../../../../api/types'
import { ErrorBoundary } from '@reapitform/utils'
import { LinkForm } from '../form-link'
import { Button, ButtonGroup } from '@reapit/elements'
import { Drawer } from '@reapitform/common-ui'

interface IAddLinkModalProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (data: IDefaultLink[] | ((preData: IDefaultLink[]) => IDefaultLink[])) => void
}

export const AddLinkModal: React.FC<IAddLinkModalProps> = ({ isOpen, onOpenChange, refreshList }) => {
  const { isLoading, addLink, isSuccess, returnData } = useDefaultsLinkPost()
  const formId: string = React.useMemo(() => 'form-add-link', [])

  const handleClose = () => onOpenChange(false)
  const handleConfirm = (data: TSchemaAddLink) => {
    addLink(data)
  }

  useEffect(() => {
    if (!isSuccess || !returnData) return

    refreshList((prevData) => [...prevData, returnData])
    handleClose()
  }, [isSuccess, returnData])

  const DrawerFooter = React.useCallback(() => {
    return (
      <ButtonGroup alignment="right">
        <Button intent="default" disabled={isLoading} onClick={handleClose}>
          Cancel
        </Button>
        <Button loading={isLoading} disabled={isLoading} intent="primary" type="submit" form={formId}>
          Add Link
        </Button>
      </ButtonGroup>
    )
  }, [handleClose, isLoading])

  return (
    <ErrorBoundary>
      <Drawer isOpen={isOpen} onDrawerClose={handleClose} footerItems={<DrawerFooter />} canDismiss title="Add Link">
        <LinkForm formId={formId} onSubmit={handleConfirm} />
      </Drawer>
    </ErrorBoundary>
  )
}
